var pug = require("!../../../../../node_modules/pug-runtime/index.js");

function template(locals) {var pug_html = "", pug_mixins = {}, pug_interp;;
    var locals_for_with = (locals || {});
    
    (function (fieldsetCounter, globals, id) {
      







































































































































































pug_mixins["radio"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.title && attributes.name) {
attributes.title = attributes.name
}
if (attributes.id) {
id = attributes.id
}
else {
id = attributes.key + '-' + attributes.index
}
pug_html = pug_html + "\u003Cinput" + (pug.attr("class", pug.classes([attributes.fieldHtmlClass], [true]), false, true)+pug.attr("id", id, true, true)+" type=\"radio\""+pug.attr("required", attributes.required, true, true)+pug.attr("name", attributes.key, true, true)+pug.attr("ng-model", attributes.key, true, true)+pug.attr("ng-disabled", attributes.readonly, true, true)+pug.attr("value", attributes.value, true, true)+pug.attr("ng-value", attributes['ng-value'], true, true)+pug.attr("data-cy", attributes['data-cy'], true, true)+pug.attr("ng-change", attributes['ng-change'], true, true)) + "\u003E";
if (attributes.title) {
pug_html = pug_html + "\u003Clabel" + (" class=\"radio-inline\""+pug.attr("for", attributes.key + '-' + attributes.index, true, true)) + "\u003E\u003Cspan\u003E" + (null == (pug_interp = attributes.title) ? "" : pug_interp) + "\u003C\u002Fspan\u003E\u003C\u002Flabel\u003E";
}
};






































































pug_mixins["validationMessages"] = pug_interp = function(){
var block = (this && this.block), attributes = (this && this.attributes) || {};
if (!attributes.formname) {
attributes.formname = globals.formname
}
pug_html = pug_html + "\u003Cdiv" + (pug.attr("ng-messages", attributes.formname +'['+ attributes.key +'].$error', false, true)) + "\u003E";
// iterate attributes.validationMessages
;(function(){
  var $$obj = attributes.validationMessages;
  if ('number' == typeof $$obj.length) {
      for (var condition = 0, $$l = $$obj.length; condition < $$l; condition++) {
        var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
      }
  } else {
    var $$l = 0;
    for (var condition in $$obj) {
      $$l++;
      var message = $$obj[condition];
pug_html = pug_html + "\u003Cdiv" + (" class=\"helpText\""+pug.attr("ng-message", condition, true, true)) + "\u003E" + (pug.escape(null == (pug_interp = message) ? "" : pug_interp)) + "\u003C\u002Fdiv\u003E";
    }
  }
}).call(this);

pug_html = pug_html + "\u003C\u002Fdiv\u003E";
};
if (!fieldsetCounter) {
fieldsetCounter = 0
}





















pug_html = pug_html + "\u003Cdiv class=\"cockpit-panel__title\" ng-if=\"!$ctrl.loading\"\u003EID: {{$ctrl.employee.customer_id}} | {{$ctrl.employee.employer_address.name}} | {{$ctrl.employee_id}}, {{ $ctrl.employee.firstname }} {{ $ctrl.employee.lastname }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"cockpit-panel__body\" overlay=\"$ctrl.loading\"\u003E\u003Cdiv class=\"row\"\u003E\u003Ch4\u003E{{ $ctrl.BONUS_COMPONENTS_BY_NAME[$ctrl.BonusService.getBonusComponentName($ctrl.bonus)].display.title }}\u003C\u002Fh4\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"columns small-1\"\u003E\u003Ch5\u003E\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003EDatum\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003ENeuer Status\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003EAlter Status\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2\"\u003E\u003Ch5\u003EBearbeiter\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3\"\u003E\u003Ch5\u003EKommentar\u003C\u002Fh5\u003E\u003C\u002Fdiv\u003E\u003Chr\u003E\u003Cdiv class=\"row\" ng-repeat=\"(bonus_project_id, bonus_project_history) in $ctrl.bonus_history_per_project\"\u003E\u003Cdiv class=\"row history-table-row\"\u003E\u003Cdiv class=\"columns\"\u003E\u003Cp class=\"center\"\u003EBonus Project ---- {{ bonus_project_history.bonus_project.name }} - {{ bonus_project_history.bonus_project.dates.bonus_project_start_date | date }} - {{ bonus_project_history.bonus_project.dates.bonus_project_end_date | date }} ----\u003C\u002Fp\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cdiv class=\"row history-table-row\" ng-repeat=\"log in bonus_project_history.bonus_history\" ng-class=\"{'odd': $odd}\"\u003E\u003Cdiv class=\"columns small-1\"\u003E{{ $ctrl.bonus_history.length - $index }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ log.created_at*1000 | date: 'dd.MM.yyyy HH:mm' }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ $ctrl.BONUS_STATES_BY_ID[log.new_bonus.state].display }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ $ctrl.BONUS_STATES_BY_ID[log.old_bonus.state].display }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-2 contract-data\"\u003E{{ $ctrl.getChangerName(log) }}\u003C\u002Fdiv\u003E\u003Cdiv class=\"columns medium-3 contract-data\"\u003E\u003Cdiv\u003E\u003Cspan ng-if=\"$ctrl.BONUS_CHANGE_REASONS_BY_ID[log.reason].show_reason_in_log\"\u003E{{ $ctrl.BONUS_CHANGE_REASONS_BY_ID[log.reason].display}};\u003C\u002Fspan\u003E\u003Cspan\u003E{{log.comment}}\u003C\u002Fspan\u003E\u003Cspan ng-if=\"$ctrl.BONUS_CHANGE_REASONS_BY_ID[log.reason]['id'] === $ctrl.BONUS_CHANGE_REASONS_BY_NAME['entity_pick_up']['id']\"\u003E{{ $ctrl.BONUS_CHANGE_REASONS_BY_ID[log.reason].display }};\u003C\u002Fspan\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003Cbr\u003E\u003Cdiv class=\"row\"\u003E\u003Cdiv class=\"column small-12\"\u003E\u003Cbutton class=\"button button-primary right\" ng-click=\"$ctrl.close()\"\u003EAbbrechen\u003C\u002Fbutton\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E\u003C\u002Fdiv\u003E";
    }.call(this, "fieldsetCounter" in locals_for_with ?
        locals_for_with.fieldsetCounter :
        typeof fieldsetCounter !== 'undefined' ? fieldsetCounter : undefined, "globals" in locals_for_with ?
        locals_for_with.globals :
        typeof globals !== 'undefined' ? globals : undefined, "id" in locals_for_with ?
        locals_for_with.id :
        typeof id !== 'undefined' ? id : undefined));
    ;;return pug_html;};
module.exports = template;